export const getUser = () => {
    const user = window.localStorage.getItem('user');
    if (user) {
        return JSON.parse(user);
    }
    return false;
};

const API_URL = 'https://backend.tenisopartneris.lt/v1';

// ── Sesija backend'e ─────────────────────────────────────────────────────────
// Facebook accessToken galioja tik ~1–2 val., o prisijungimas čia laikomas
// mėnesiais. Todėl iškart po FB prisijungimo (kol token'as šviežias) jis
// iškeičiamas į backend'o sesiją, kuri siunčiama su rezervavimu ir atšaukimu —
// taip backend'as žino, kas iš tikrųjų rezervuoja.
//
// Nepavykus gauti sesijos (FB ar tinklo trikdis) niekas nestabdoma: rezervacijos
// veikia kaip anksčiau, kol backend'e neįjungtas griežtas režimas.
// Grąžina { token } arba { token: null, expired } — `expired` reiškia, kad FB
// token'as nebegalioja (ne laikinas tinklo trikdis).
const requestSession = async (accessToken) => {
    if (!accessToken) return { token: null, expired: true };
    try {
        const response = await fetch(`${API_URL}/bookcourt/session`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ accessToken }),
        });
        if (!response.ok) return { token: null, expired: response.status === 401 };
        const data = await response.json();
        return { token: data.token || null, expired: false };
    } catch (err) {
        return { token: null, expired: false };
    }
};

export const exchangeSession = async (accessToken) => (await requestSession(accessToken)).token;

// Jau prisijungusiems iki šios versijos: bandom gauti sesiją su turimu FB
// token'u (pavyks, jei jis dar galioja). Jei FB token'as pasibaigęs — tai
// pažymim ir daugiau nebandom: kitaip kiekvienas puslapio atidarymas
// backend'e paliktų po 401. Sesiją toks vartotojas gaus kitą kartą
// prisijungęs per Facebook.
export const ensureSession = async () => {
    const user = getUser();
    if (!user || user.sessionToken || !user.accessToken || user.sessionExpired) return;
    const { token, expired } = await requestSession(user.accessToken);
    if (token) {
        window.localStorage.setItem('user', JSON.stringify({ ...getUser(), sessionToken: token }));
    } else if (expired) {
        window.localStorage.setItem('user', JSON.stringify({ ...getUser(), sessionExpired: true }));
    }
};

export const authHeaders = () => {
    const user = getUser();
    return user && user.sessionToken ? { Authorization: `Bearer ${user.sessionToken}` } : {};
};

// Backend'as atsakė 401 — sesija nebegalioja (arba jos nėra, o griežtas režimas
// jau įjungtas). Išvalom prisijungimą ir grąžinam į prisijungimo puslapį.
export const handleSessionExpired = (message) => {
    window.alert(message || 'Prisijungimas nebegalioja — prisijunkite per Facebook iš naujo.');
    window.localStorage.removeItem('user');
    window.location.href = '/';
};

export const TournamentLevel = [
    {
        value: 'Light',
        label: 'Light (NTRP 2.5)',
    },
    {
        value: 'Middle',
        label: 'Middle (NTRP 3.0)',
    },
    {
        value: 'Power',
        label: 'Power (NTRP 3.5)',
    },
    {
        value: 'Hard',
        label: 'Hard (NTRP 4.0)',
    },
];
